import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { rand, randNumber, randUuid } from '@ngneat/falso'

import type { SchemaAttributes } from '../../types.js'
import { getTodayDateTimeISO } from '@/utils/date/getter.js'
import { CONSTANTS } from './constants.js'

export type ConversationMessageMediaData =
  SchemaAttributes<'ConversationMessageMedia'>

export const model = (
  Model as ModelDefinition<ConversationMessageMediaData>
).extend({
  message: belongsTo('message'),
})

export const factory = Factory.extend<ConversationMessageMediaData>({
  storage_type() {
    return 'external'
  },
  is_file_available() {
    return true
  },
  duration() {
    return null
  },
  width() {
    return null
  },
  height() {
    return null
  },
  file_name() {
    return CONSTANTS.media.sampleFiles[0].file_name
  },
  mime_type() {
    return CONSTANTS.media.sampleFiles[0].mime_type
  },
  media_type() {
    return CONSTANTS.media.sampleFiles[0].media_type
  },
  url() {
    return `https://mock-storage.example.com/media/${randUuid()}`
  },
  file_size() {
    return randNumber({ min: 10_000, max: 5_000_000 })
  },
  added_at() {
    return getTodayDateTimeISO()
  },
  afterCreate(media) {
    const sample = rand([...CONSTANTS.media.sampleFiles])
    media.update({
      file_name: sample.file_name,
      mime_type: sample.mime_type,
      media_type: sample.media_type,
    })
  },
})

export function routes() {}

export function seeds() {}
